$('.strongerImmunitySlider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0666/9513/5519/files/arrow-left.svg?v=1676315685" alt=""></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0666/9513/5519/files/arrow-right.svg?v=1676315702" alt=""></img></button>',
    centerMode: true,
    asNavFor: '.strongerImmunityThumbsSlider',
    responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
});

$('.strongerImmunityThumbsSlider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    centerMode: true,
    asNavFor: '.strongerImmunitySlider'
});

$('.slick.productSpecsMarqueeSlider').slick({
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: false,
    buttons: false,
    rtl:false
});

$('.reviewsSlider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    centerMode: false,
    autoplay: true
});

$('.featureProductImage').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    asNavFor: '.featureProductImageThumbnail',
});
$('.featureProductImageThumbnail').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    asNavFor: '.featureProductImage'
});

$(document).ready(function(){

    $(function () {
        $(".faqAccordionSingle").slice(0, 3).show();
        
        $(".homeFaqContainer").on('click touchstart', '.faqLoadMore a', function (e) {
          e.preventDefault();
          $(".faqAccordionSingle:hidden").slice(0, 3).slideDown();
          if ($(".faqAccordionSingle:hidden").length == 0) {
            $(".faqLoadMore a").css('visibility', 'hidden');
          }
          $('html,body').animate({
            scrollTop: $(this).offset().top
          }, 1000);
        });
    });




    $('.faqAccordionSingle:first-child').addClass('active');
    $('.faqAccordionSingle:first-child .faqHead').addClass('active');
    $('.faqAccordionSingle:first-child .faqBody').slideDown();
    $('.faqHead').click(function(){
        $(this).parent().find('.faqBody').slideToggle();
        $(this).toggleClass('active');
        $(this).parent().parent().toggleClass('active');
        $(this).parent().parent().siblings().children().find('.faqBody').slideUp();
        $(this).parent().parent().siblings().children().find('.faqHead').removeClass('active');
        $(this).parent().parent().siblings().removeClass('active');
    }); 
    
    $('.headerHamburger').click(function(){
        $(this).toggleClass('active');
        $('.siteHeaderCenter').slideToggle();
        $('body').toggleClass('overflow');
    });
});